import { createEnum } from '../../../core/createEnum';

/**
 * @typedef {Object} FeatureEntryType
 * @property {string} label
 * @property {(selectedLink: any) => boolean} isSetOn
 */

class FeatureEntry {
  constructor(name, { label }) {
    this[this.nameSym] = this.symbolFor(name);
    this.label = label;
    Object.freeze(this);
  }

  isSetOn(selectedLink) {
    return (
      selectedLink &&
      selectedLink.partnerAccount &&
      selectedLink.partnerAccount.features.includes(
        this.nameOfSym(this[this.nameSym]),
      )
    );
  }
}

FeatureEntry.prototype.nameSym = Symbol('FeatureEntry.name');
FeatureEntry.prototype.symbolFor = (name) => Symbol.for(`com.tikeasy.${name}`);
FeatureEntry.prototype.nameOfSym = (sym) => {
  const fullName = Symbol.keyFor(sym);
  return fullName.substr((~-fullName.lastIndexOf('.') >>> 0) + 2);
};

class FeatureEnum {
  constructor(enumLiterals) {
    const _this = this;
    Object.keys(enumLiterals).forEach(
      (key) => (_this[key] = new FeatureEntry(key, enumLiterals[key])),
    );

    Object.freeze(this);
  }

  keys() {
    return Object.keys(this);
  }

  values() {
    const result = Array.from({ length: this.keys().length });
    const _this = this;

    this.keys().forEach((key) => result.push(_this[key]));

    return result;
  }

  labelOf(featureName, orElse = '') {
    return this.hasOwnProperty(featureName) ? this[featureName].label : orElse;
  }
}

/**
 * @template {Record<string, {label: string}>} T
 * @param {T} enumLiterals
 * @returns {Readonly<Record<keyof T, FeatureEntryType>> & FeatureEnum}
 */
function createFeatureEnum(enumLiterals) {
  return /** @type {Readonly<Record<keyof T, FeatureEntryType>> & FeatureEnum} */ (
    createEnum(FeatureEnum, enumLiterals)
  );
}

const Features = createFeatureEnum({
  ADD_ARTICLE: { label: 'Ajouter des articles' },
  ADD_BOOKMARK: { label: 'Ajouter des liens internet' },
  ADD_DOCUMENT: { label: 'Ajouter des documents' },
  ADD_GOOD_DEAL: { label: 'Ajouter des bons plans' },
  ADD_RECOMMENDED_APP: { label: 'Ajouter des applications recommandées' },
  ADD_BUTTON_BELOW_ARTICLE: {
    label: 'Ajouter un bouton de renvoi vers un lien à la fin des articles',
  },
  VIEW_STATISTICS: { label: 'Visualiser les statistiques' },
  HAS_MATOMO_SEGMENT: { label: 'Le partenaire a un segment Matomo' },
  HOROSCOPE_MANAGER: { label: `Profil gestionnaire d'horoscope` },
  PODCAST_MANAGER: { label: `Profil gestionnaire de podcasts` },
  ADD_NOTRE_TEMPS_CONTENTS: { label: 'Fonctionnalités Notre Temps' },
  WITH_ONBOARDING: {
    label:
      'Publier des contenus après un nombre de jours définis après initialisation de la tablette (Onboarding)',
  },
  WITH_WEIGHT_FIELD: { label: 'Ordonner les contenus' },
  HAS_FAMILY_PORTAL: { label: 'Afficher le contenu dans le site famille' },
  CAN_EDIT_PARTNER_CONTACT: { label: 'Contact du partenaire sur la tablette' },
  CAN_SET_PRIORITY_EMAIL_ADDRESS: { label: 'Mail prioritaire sur la tablette' },
});

export { Features };
